module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_vm._v("\n\t\t\tMultiMentions\n\t\t\t"), _c('button', {
    class: {
      '-active': _vm.showHelp
    },
    on: {
      "click": _vm.toggleHelp
    }
  }, [_c('c-icon', {
    attrs: {
      "name": 'question-circle'
    }
  })], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "e-grid -triple -center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('label', {
    staticClass: "c-multimentions-input"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accounts),
      expression: "accounts"
    }],
    staticClass: "e-input-text -full",
    attrs: {
      "placeholder": "@mach3ss, @codogue"
    },
    domProps: {
      "value": (_vm.accounts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accounts = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    staticClass: "c-multimentions-input"
  }, [_c('div', {
    staticClass: "c-multimentions-input__title"
  }, [_c('span', {
    staticClass: "c-multimentions-input__label"
  }, [_vm._v("メッセージ")]), _vm._v(" "), _c('span', {
    staticClass: "c-multimentions-input__counter",
    class: {
      '-caution': 140 < _vm.messageLength
    }
  }, [_vm._v(_vm._s(140 - _vm.messageLength))])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "e-input-text -full",
    class: {
      '-invalid': 140 < _vm.messageLength
    },
    attrs: {
      "placeholder": "メッセージを入力"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', [_c('button', {
    staticClass: "e-button -primary -full",
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("メッセージ生成")])]), _vm._v(" "), _c('label', {
    staticClass: "e-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.insertPeriod),
      expression: "options.insertPeriod"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.insertPeriod) ? _vm._i(_vm.options.insertPeriod, null) > -1 : (_vm.options.insertPeriod)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.options.insertPeriod,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.options.insertPeriod = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.options.insertPeriod = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.options.insertPeriod = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("先頭にピリオドをつける")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('div', {
    staticClass: "c-multimentions-account-list"
  }, [_c('ul', {
    staticClass: "c-multimentions-account-list__list"
  }, _vm._l((_vm.accountList), function(item) {
    return _c('li', {
      staticClass: "c-multimentions-account-list__item"
    }, [_vm._v(_vm._s(item))])
  }))])]), _vm._v(" "), _c('hr', {
    staticClass: "e-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('transition', {
    attrs: {
      "name": "slide-in"
    }
  }, [(_vm.errors.length) ? _c('div', {
    staticClass: "c-error-list"
  }, [_c('ul', {
    staticClass: "c-error-list__list"
  }, _vm._l((_vm.errors), function(error) {
    return _c('li', {
      staticClass: "c-error-list__item"
    }, [_c('c-icon', {
      attrs: {
        "name": 'error'
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(error.message) + "\n\t\t\t\t\t\t")], 1)
  }))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-in"
    }
  }, [(_vm.results.length) ? _c('div', {
    staticClass: "c-multimentions-result"
  }, [_c('ul', {
    staticClass: "c-multimentions-result__list"
  }, _vm._l((_vm.results), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "c-multimentions-result__item",
      class: {
        '-disabled': item.done
      }
    }, [_c('div', {
      staticClass: "message"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.message),
        expression: "item.message"
      }],
      staticClass: "e-input-text -full",
      attrs: {
        "readonly": ""
      },
      domProps: {
        "value": (item.message)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.message = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "button"
    }, [_c('button', {
      staticClass: "c-multimentions-result__button-tweet",
      on: {
        "click": function($event) {
          _vm.tweet(item.message)
        }
      }
    }, [_vm._v("@")])])])
  }))]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-help"
  }, [_c('div', {
    staticClass: "c-help__inner"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t多数のユーザーに向けた一括メンションツイートを分割生成するジェネレータです。\n\t\t\t\t")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("宛先（リスト）とメッセージを入力して生成ボタンを押すと結果が出力されます")]), _vm._v(" "), _c('li', [_vm._v("宛先はアカウント名とおぼしき文字列を自動抽出します")]), _vm._v(" "), _c('li', [_vm._v("メッセージ内のURL文字列は t.co で短縮された物として計算されます")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-multimentions-input__title"
  }, [_c('span', {
    staticClass: "c-multimentions-input__label"
  }, [_vm._v("@宛先")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6d44948","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/multimentions.vue
// module id = 71
// module chunks = 0